<style lang="scss" scoped>
  @import "~bootstrap/scss/vendor/rfs";

  .card-info-user {
    min-height: 198px;

    > .user-name {
      color: #3b334a;
      font-family: "Montserrat";
      @include font-size(16px);
      font-weight: 400;
      letter-spacing: -0.24px;
      line-height: 25px;
    }
    > .user-email {
      color: #857a98;
      font-family: "Montserrat";
      font-size: 0.685rem;
      font-weight: 400;
      letter-spacing: -0.17px;
      line-height: 25px;
    }
    > ul.user-attributes {
      list-style: none;
      padding: 0;
      margin: 1.1875rem 0 0 0;

      > .attribute {
        color: #3b334a;
        font-family: Montserrat;
        @include font-size(13px);
        font-weight: 400;
        letter-spacing: -0.2px;
        line-height: 25px;
      }
    }

    > .actions-area {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      box-shadow: 0 5px 20px rgba(165, 131, 224, 0.15);
      border-radius: 0 0 15px 15px;
      background-color: #f6f5f8;
      height: 0;
      align-items: center;
      display: flex;
      flex: 0;
      padding: 0 1.875rem;
      overflow: hidden;
      transition: all 150ms;

      > .btn {
        background-color: #2ceba9;
        border-radius: 23px;
        color: #130f19;
        font-family: "Montserrat";
        @include font-size(14px);
        font-weight: 400;
        border: 0;
        padding: 9px 23px;
      }

      > .icon {
        color: #3b334a;
        @include font-size(18px);
        background-color: transparent;
        border: 0;
      }
    }

    &:hover {
      > .actions-area {
        flex: 1;
        height: 88px;
      }
    }
  }
</style>

<template>
  <div class="card card-info-user">
    <div class="user-name">
      {{ name }}
    </div>
    <div class="user-email">
      {{ email }}
    </div>
    <ul class="user-attributes">
      <li class="attribute">
        <strong>Grupo:</strong> {{ role.name }}
      </li>
      <li class="attribute">
        <strong>Cadastro</strong> {{ createdAt | ago }}
      </li>
      <li
        class="attribute"
        v-if="lastSeenAt.trim()"
      >
        <strong>&Uacute;ltimo acesso:</strong> {{ lastSeenAt | ago }}
      </li>
    </ul>
    <div class="actions-area">
      <a
        class="btn btn-success"
        :href="href"
      >Ver mais</a>
      <button
        class="icon ml-auto"
        @click="$emit('destroy')"
      >
        <i class="fa fa-trash-o" />
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardInfoUser',

  props: {
    name: {
      type: String,
      required: true,
    },
    email: {
      type: String,
      required: true,
    },
    role: {
      type: Object,
      required: true,
    },
    createdAt: {
      type: String,
      required: true,
    },
    lastSeenAt: {
      type: String,
      required: false,
      default: '',
    },
    href: {
      type: String,
      required: true,
    },
  },
};
</script>
